import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA,MatDialog,MatDialogRef } from '@angular/material/dialog';
import { NotificationService } from 'src/app/core/services/notification/notification.service';
import { TranslateApplicationService } from 'src/app/core/translate/translate-application-service';
import { IVisitors } from '../../Interfaces/IVisitors';
import { VisitsService } from '../../services/visits-service';
import { IVisits } from '../../Interfaces/IVisits';
import { TransactionResult } from 'src/app/core/services/interfaces/transaction-result';
import { IProperties } from '../../Interfaces/IProperties';
import { UploadFileService } from '../../services/upload-file.service';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { IVisitorFilesImagenes } from '../../Interfaces/IVisitorFiles';
import { PropertiesService } from '../../services/properties-services';
import { IEvidenceTypes } from '../../Interfaces/IEvidenceTypes';
import { EvidenceTypesService } from '../../services/evidencetypes-services';

@Component({
	selector: 'app-upload-image-photo',
	templateUrl: './upload-image-photo.component.html',
	styles: [],
})
export class UploadImagePhotoComponent implements OnInit {
	formGroup: FormGroup;
	loading = false;
	selectedFiles: FileList;

	visit: IVisits = {
		pkvisit: 0,
		fkvisittype: 0,
		visittype: '',
		startdatevisit: new Date(),
		strstartdatevisit: '',
		enddatevisit: new Date(),
		strenddatevisit: '',
		fkbuilding: 0,
		building: '',
		fkcompanysupplier: 0,
		companysupplier: '',
		fkidentificationtype: 0,
		identificationtype: '',
		fkactivity: 0,
		activity: '',
		areaproject: '',
		fkarea: 0,
		fkproject: 0,
		fkemployee: 0,
		sponsorname: '',
		sponsorname2: '',
		sponsor: '',
		recordstatus: '',
		creationdate: new Date(),
		strcreationdate: '',
		fkemployeecreator: 0,
		lastupdated: new Date(),
		strlastupdated: '',
		fkemployeeupdater: 0,
		fksite: 0,
		username: '',
		usernamesponsor: '',
		workdayid: '',
		email: '',
		employeename: '',
		employeenumber: '',
		phone: '',
		position: '',
		visitorname: '',
		startofwork: false,
		fksupplierincometype: 0,
		supplierincometype: '',
		strstarthour: '',
		strendhour: '',
		fkactivitytype: 0,
		activitytype: '',
		activitydescription: '',
		criticalwork: false,
		fksubtypevisit: 0,
		requisitionid: '',
		fk_origin_site: 0,
		fk_origin_building: 0,
		visitorworkdayid: '',
		startYear: '',
		startMonth: '',
		startDay: '',
		startHour: '',
		startMinute: '',
		endYear: '',
		endMonth: '',
		endDay: '',
		endHour: '',
		endMinute: '',
		fksponsor: 0,
    	isViewing: false,
		pkStatus:[],
    	project: '',
		hasHistory: false,
	};

	dataFileSend: IVisitorFilesImagenes = {
		pkvisitorfileid: 0,
		visitorfileid: '',
		pkvisitorsfilesphoto: 0,
		visitorsfilesphoto: '',
		pkfile: 0,
		filename: '',
		fkvisitor: 0,
		nameinbucket: '',
		creationdate: new Date(),
		fkemployeecreator: 0,
		lastupdated: new Date(),
		fkemployeeupdater: 0,
		available: false,
		fksite: 0,
		username: '',
		pkvisitorbyvisit: 0,
		signature: '',
	};

	BUCKET: string = '';
	REGION: string = '';
	FOLDER: string = '';
	NAME: string = '';
	fileType: number = 0;
  idUploaded: boolean = false;
  validExtensionFile: boolean = false;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: IVisitors,
		private dialog: MatDialog,
		private dialogRef: MatDialogRef<UploadImagePhotoComponent>,
		public evidenceTypeService: EvidenceTypesService,
		private formBuilder: FormBuilder,
		private notificationService: NotificationService,
		private translate: TranslateApplicationService,
		private visitsService: VisitsService,
		public uploadFileService: UploadFileService,
		public httpClient: HttpClient,
		public propertyService: PropertiesService,
	) {
		this.formGroup = this.formBuilder.group({
			pkvisit: [data.pkvisit],
			pkvisitor: [data.pkvisitor],
			pkvisitorphoto: [0],
		});
	}

	ngOnInit(): void {
		this.dataFileSend.fkvisitor = this.formGroup.controls.pkvisitor.value;
	}

	AddEvidence() {
		this.loading = true;
		if (this.formGroup.controls.pkvisitorphoto.value == 0) {
			this.visitsService.SetImagePhoto(this.dataFileSend).subscribe(
			(result: TransactionResult<number>) => {
        if (result.success) {
          this.loading = false;
          this.Alert("Success", "NDAs.File_uploaded")
					this.dialogRef.close(this.formGroup.value);
        } else {
          this.loading = false;
          this.Alert("Error", "MYREQUEST.Error_loading_file");
        }
			},
			(error: any) => {
				this.ErrorAlert(error);
				this.loading = false;
			});
		} else {
      this.UpdatePhoto();
		}
	}

	Alert(title: string, message: string) {
		this.notificationService.AddAlert({
			icon: 'all_inbox',
			title: title,
			message: this.translate.TranslateKey(message),
			shown: true,
		});
  }
  
  AlertProperties(title: string, message: string, property: string) {
		this.notificationService.AddAlert({
			icon: 'all_inbox',
			title: title,
			message: this.translate.TranslateKey(message) + ": " + property,
			shown: true,
		});
  }

	Close() {
		this.dialogRef.close(this.formGroup.controls.pkvisit.value);
	}

	ConfigureIncident(result: TransactionResult<any>, file: File) {
		this.loading = true;
		var url = result.data.url;
		const formData = new FormData();
		var a = result.data.fields['Content-Type'];
		formData.append('Content-Type', result.data.fields['Content-Type']);
		formData.append('key', result.data.fields.key);
		formData.append('AWSAccessKeyId', result.data.fields.AWSAccessKeyId);
		formData.append('policy', result.data.fields.policy);
		formData.append('signature', result.data.fields.signature);
		formData.append(
			'x-amz-security-token',
			result.data.fields['x-amz-security-token'],
		);
		formData.append('file', file);
		return { url, formData };
	}

  ErrorAlert(message: any) {
		this.notificationService.AddAlert({
			icon: 'all_inbox',
			title: 'Error',
			message: message,
			shown: true,
		});
  }
  
	EvidenceDataConfiguration(file: File,presignedAPIURLResult: TransactionResult<IProperties[]>) {
		this.loading = true;
		this.uploadFileService.UploadPreSignedUrl(this.FOLDER + 'VisitorPhotos/' + this.NAME, file.type, presignedAPIURLResult.data[0].propertyvalue).subscribe(
		(result: TransactionResult<any>) => {
			if (result.success) {
				var { url, formData } = this.ConfigureIncident(result,file);
				this.httpClient.post(url, formData, {observe: 'events', reportProgress: true}).subscribe(
				(result) => {
					if (result.type === HttpEventType.UploadProgress) {
					} else if (result.type == HttpEventType.Response) {
            this.loading = true;
						
						this.dataFileSend.filename = file.name;
						this.dataFileSend.fkvisitor = this.formGroup.controls.pkvisitor.value;
						this.dataFileSend.nameinbucket = 'VisitorPhotos/' + this.NAME;
						this.AddEvidence();
					}
				});
      } else {
        this.loading = false;
        this.Alert("Error", "MYREQUEST.Error_loading_file");
      }
		},
    (error: any) => {
      this.ErrorAlert(error);
      this.loading = false;
    });
	}

	ExtensionFileSuccess(file: File) {
		this.loading = true;
		this.propertyService.GetPropertyByName('BUCKET_APPLICATION_PATH').subscribe(
		(result: TransactionResult<IProperties[]>) => {
			if (result.success) {
				this.FOLDER = result.data[0].propertyvalue;
				this.NAME = this.GetUniqueId(10) + '.' + file.name.split('.')[1];
				this.loading = true;
				this.propertyService.GetPropertyByName('S3_Bucket_PRESIGNED_URL_API').subscribe(
				( presignedAPIURLResult: TransactionResult<IProperties[]> ) => {
					if (presignedAPIURLResult.success) {
						this.EvidenceDataConfiguration(file,presignedAPIURLResult);
          } else {
            this.loading = false;
            this.AlertProperties("Error", "WARNINGS.Property_not_found", "S3_Bucket_PRESIGNED_URL_API");
          }
				},
				(error: any) => {
					this.ErrorAlert(error);
					this.loading = false;
				});
      } else {
        this.loading = false;
        this.AlertProperties("Error", "WARNINGS.Property_not_found", "BUCKET_APPLICATION_PATH");
      }
		},
		(error: any) => {
			this.ErrorAlert(error);
			this.loading = false;
		});
	}

	GetUniqueId(parts: number): string {
		this.loading = true;
		const stringArr = [];
		for (let i = 0; i < parts; i++) {
			const S4 = (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
			stringArr.push(S4);
		}
		return stringArr.join('-');
	}

	SelectFile(event) {
    this.selectedFiles = event.target.files;
    this.ValidateExtensionFiles();
	}

	UpdatePhoto() {
		this.loading = true;
		this.visitsService.UpdatePhoto(this.dataFileSend).subscribe(
			(result: TransactionResult<number>) => {
        if (result.success) {
          this.loading = false;
					this.Alert("Success", "NDAs.File_uploaded");
					this.dialogRef.close(this.formGroup.value);
        } else {
          this.loading = false;
          this.Alert("Error", "ERROR.Failed_to_update_file");
        }
			},
			(error: any) => {
				this.ErrorAlert(error);
				this.loading = false;
			},
		);
	}

	UploadPhoto() {
		for (var i = 0; i < this.selectedFiles.length; i++) {
			const file = this.selectedFiles.item(i);
      var filename = file.name.substr(file.name.lastIndexOf('.') + 1);
      this.evidenceTypeService.GetEvidenceTypeByExtensionFile('.' + filename).subscribe(
      (result: TransactionResult<IEvidenceTypes[]>) => {
        if (result.success) {
          if (result.data[0] != null) {
            this.ExtensionFileSuccess(file);
          }
        } else {
          this.loading = false;
          this.Alert("Warning", "ERROR.ExtensionError");
        }
      },
      (error: any) => {
        this.ErrorAlert(error);
        this.loading = false;
      });
		}
  }
  
  ValidateExtensionFiles() {
    this.validExtensionFile = true;
    for (var i = 0; i < this.selectedFiles.length; i++) {
      const file = this.selectedFiles.item(i);
      if (file.type.includes('image/') == false) {
        this.validExtensionFile = false;
        break;
      }
    }
  }

	ValidateVisitor() {
		this.visitsService.SetVisitor(this.data).subscribe(
		(result: TransactionResult<number>) => {
			if (result.success) {
				this.formGroup.controls.pkvisitor.setValue(result.data);
				this.UploadPhoto();
      } else {
        this.loading = false;
        this.Alert("Error", "MYREQUEST.Save_visitor_information_fail");
      }
		},
		(error: any) => {
			this.loading = false;
		});
  }

}
